export default __webpack_public_path__ + "static/media/Uahs.5f312d2b.png";